import { connect } from 'react-redux';

import ForbiddenPage from 'components/pages/ForbiddenPage';

const mapStateToProps = () => ({

});

const mapDispatchToProps = () => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForbiddenPage);
